import { FormControlLabel, Radio, Stack, SxProps, Typography } from '@mui/material';
import React from 'react';
import { labelFontSemiBold, vars } from '../../../../../Theme';
import {
    InitialReleaseFinalOption,
    InitialReleaseRoleOption,
} from '../../../../../redux/project/sliceProjectWorkflow';

const radioSx: SxProps = {
    padding: '8px 12px',
};

const labelSx: SxProps = {
    ml: 0,
    ' span': {
        fontFamily: labelFontSemiBold,
        fontSize: '16px',
    },
};

export default ({ task, exclusiveSelectComputed }: ISelectWorkflowNestedOptionProps) => (
    <FormControlLabel
        value={task.path}
        checked={exclusiveSelectComputed.includes(task.path)}
        control={<Radio sx={radioSx} />}
        label={
            <Stack direction='row' sx={{ ml: 0 }}>
                <Stack sx={{ ml: 0 }}>
                    <Typography
                        sx={{
                            ...labelFontSemiBold,
                            color: vars.font,
                        }}
                    >
                        {task.workflowTaskTitle}
                    </Typography>
                </Stack>
            </Stack>
        }
        sx={labelSx}
    />
);

interface ISelectWorkflowNestedOptionProps {
    task: InitialReleaseFinalOption | InitialReleaseRoleOption;
    exclusiveSelectComputed: string;
}
